import { Popover, Flex, Checkbox, Button } from 'antd'
import { ColumnTitle } from 'antd/es/table/interface'
import { useTheme } from 'antd-style'

import { ColumnsIcon } from 'src/assets'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

type OptionType<T> = {
  label: ColumnTitle<T>
  value: string
}

type ColumnTableFilterProps<T> = {
  options: OptionType<T>[]
  hiddenColumns: string[]
  onChange: (value: string) => void
}

export const ColumnTableFilter = <T extends Record<string, unknown>>({
  options,
  hiddenColumns,
  onChange
}: ColumnTableFilterProps<T>) => {
  const { t } = useLocales()
  const palette = useTheme()

  return (
    <Popover
      trigger={'click'}
      placement="bottomRight"
      content={
        <Flex vertical gap={8}>
          {options.map((item) => (
            <Checkbox
              key={item.value}
              checked={!hiddenColumns.includes(item.value)}
              onChange={() => onChange(item.value)}
            >
              <Text weight={600}>{item.label as React.ReactNode}</Text>
            </Checkbox>
          ))}
        </Flex>
      }
    >
      <Button color="primary">
        <ColumnsIcon color={palette.colorPrimary} />
        <Text color={palette.colorPrimary}>{t('common.columns')}</Text>
      </Button>
    </Popover>
  )
}
